import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useApi } from "../../../../services/HttpService";

export const CreateDCP = (props: { open: boolean; onClose: () => void }) => {
  const [projectName, setProjectName] = useState("");
  const [hostIdentifier, setHostIdentifier] = useState("");
  const [website, setWebsite] = useState(true);
  const [adminEmail, setAdminEmail] = useState("");
  const [projectType, setProjectType] = useState("site-simple");
  const [language, setLanguage] = useState("nor-NO");

  const { api, isLoading, error } = useApi();

  const submit = () => {
    const data = {
      name: projectName,
      host: hostIdentifier,
      language,
      website,
      admin_email: adminEmail,
      projectType,
    };
    api("/la-dcp/create", "POST", data).then((res) => {
      if (res) {
        if (res.statusCode === 200) {
        } else {
        }
      }
    });
  };

  return (
    <Dialog open={props.open}>
      <DialogTitle>Create project</DialogTitle>
      <DialogContent>
        <form>
          <FormControl fullWidth={true}>
            <label>Project name:</label>
            <TextField
              size="small"
              required
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
            />
          </FormControl>
          <FormControl sx={{ mt: 1 }} fullWidth={true}>
            <label>Project type:</label>
            <Select
              size="small"
              value={projectType}
              onChange={(e) => setProjectType(e.target.value)}
            >
              <MenuItem value={"site-simple"}>Simple site</MenuItem>
              <MenuItem value={"empty"}>Pure content</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mt: 1 }} fullWidth={true}>
            <label>Host identifier:</label>
            <TextField
              size="small"
              placeholder="Eg. parat or bridge"
              onChange={(e) => setHostIdentifier(e.target.value)}
            />
          </FormControl>

          <FormControl sx={{ mt: 1 }} fullWidth={true}>
            <label>
              Has website:
              <Checkbox
                checked={website}
                onChange={(e) => setWebsite(e.target.checked)}
              />
            </label>
          </FormControl>

          <FormControl sx={{ mt: 1 }} fullWidth={true}>
            <label>Website language:</label>
            <Select
              size="small"
              value={language}
              onChange={(e) => setProjectType(e.target.value)}
            >
              <MenuItem value={"nor-NO"}>Norwegian</MenuItem>
              <MenuItem value={"eng-Gb"}>English</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ mt: 1 }} fullWidth={true}>
            <label>Admin email:</label>
            <TextField
              type="email"
              required
              size="small"
              placeholder=""
              onChange={(e) => setAdminEmail(e.target.value)}
            />
          </FormControl>
          {error && (
            <Alert sx={{ mt: 1 }} color="error">
              {error}
            </Alert>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={submit}>
          Confirm
        </Button>
        <Button onClick={props.onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
